// Presentation adapter for the native record-comment drawer. Native comment.js
// continues to own authorization, channels, requests, drafts and posting.
(function () {
  'use strict';
  if (document.documentElement.dataset.lpCommentDrawerReady) { return; }
  document.documentElement.dataset.lpCommentDrawerReady = 'true';
  var hr = /^hr(?:-|$)/i.test(document.documentElement.lang || '');
  var words = hr ? {title:'Komentari',close:'Zatvori',context:'Rasprava o zapisu',empty:'Započnite razgovor',emptyNote:'Još nema internih bilješki',hint:'Dodajte prvi komentar ovom zapisu.',noteHint:'Dodajte bilješku kako biste sačuvali kontekst ovog zapisa.',write:'Dodajte komentar',writeNote:'Dodajte internu bilješku'}
    : {title:'Comments',close:'Close',context:'Record discussion',empty:'Start a conversation',emptyNote:'No internal notes yet',hint:'Add the first comment to this record.',noteHint:'Add a note to keep the context with this record.',write:'Add a comment',writeNote:'Add an internal note'};
  function attr(node, key, value) { if (node && node.getAttribute(key) !== value) { node.setAttribute(key, value); } }
  function decorate() {
    var drawer = document.getElementById('lxpDialog_comments');
    if (!drawer) { return; }
    var title = drawer.querySelector('.ui-dialog-title');
    if (title) {
      title.id = 'lp-comments-drawer-title';
      if (title.textContent !== words.title) { title.textContent = words.title; }
      attr(drawer,'aria-labelledby',title.id);
      if (!title.closest('.lp-comments-header-copy')) {
        var copy=document.createElement('div');copy.className='lp-comments-header-copy';
        var context=document.createElement('span');context.className='lp-comments-context';context.textContent=words.context;
        title.before(copy);copy.append(context,title);
      }
    }
    var body = drawer.querySelector('.lxpDialog__body');
    if (body) { body.id = 'lp-comments-drawer-body'; attr(drawer,'aria-describedby',body.id); }
    var close = drawer.querySelector('.ui-dialog-titlebar-close');
    attr(close,'aria-label',words.close); attr(close,'title',words.close);
    var root = drawer.querySelector('.comments');
    if (!root) { return; }
    var form = root.querySelector('.postForm');
    // Match DOM and visual order while retaining all original nodes/handlers.
    if (form && form !== root.lastElementChild) { root.appendChild(form); }
    if(form){
      var input=form.querySelector('textarea'),composerLabel=form.querySelector('.lp-comments-composer-label');
      if(input&&!composerLabel){
        if(!input.id)input.id='lp-comments-drawer-input';
        composerLabel=document.createElement('label');composerLabel.className='lp-comments-composer-label';composerLabel.htmlFor=input.id;form.prepend(composerLabel);
      }
      var note=form.querySelector('.note');if(note)attr(note,'data-lp-empty',String(!note.textContent.trim()));
      var post=form.querySelector('nav.t-Button');
      if(post){attr(post,'role','button');attr(post,'tabindex','0');if(!post.dataset.lpKeyboard){post.dataset.lpKeyboard='true';post.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();post.click();}});}}
    }
    root.querySelectorAll('.t-Tabs-link[role="tab"]').forEach(function (tab) {
      var owner = tab.closest('li');
      var key = owner.getAttribute('aria-controls');
      var panel = root.querySelector('.' + key);
      if (!panel) { return; }
      var active = owner.classList.contains('is-active');
      attr(tab,'id','lp-comments-tab-' + key);
      attr(panel,'id','lp-comments-panel-' + key);
      attr(tab,'aria-controls',panel.id); attr(tab,'aria-selected',String(active));
      attr(panel,'aria-labelledby',tab.id); attr(panel,'aria-hidden',String(!active));
      if (active && form) {
        var input = form.querySelector('textarea');
        var label = tab.querySelector('span:first-child');
        if (input && label) { attr(input,'aria-label',label.textContent.trim()); }
        var composerLabel=form.querySelector('.lp-comments-composer-label');
        var labelText=/Internal/.test(key)?words.writeNote:words.write;
        if(composerLabel&&composerLabel.textContent!==labelText)composerLabel.textContent=labelText;
      }
      if (!/Internal|Shared/.test(key)) { return; }
      var empty = panel.querySelector('.lp-comments-empty');
      var populated = panel.querySelector('.lxpComment, .commentShowMore');
      if (populated && empty) { empty.remove(); }
      if (!populated && !empty) {
        empty = document.createElement('div'); empty.className = 'lp-comments-empty';
        var icon=document.createElement('i');icon.className='far '+(/Internal/.test(key)?'fawe-lock':'fawe-comment-alt-lines');icon.setAttribute('aria-hidden','true');
        var heading=document.createElement('h3');heading.textContent=/Internal/.test(key)?words.emptyNote:words.empty;
        var hint=document.createElement('p');hint.textContent=/Internal/.test(key)?words.noteHint:words.hint;
        empty.append(icon,heading,hint);panel.appendChild(empty);
      }
    });
  }
  function start() {
    var queued = false;
    new MutationObserver(function (records) {
      if (!records.some(function (r) {
        return r.target.closest && (r.target.closest('#lxpDialog_comments') ||
          Array.prototype.some.call(r.addedNodes,function(n){return n.nodeType===1 && (n.id==='lxpDialog_comments' || n.querySelector('#lxpDialog_comments'));}));
      })) { return; }
      if (queued) { return; } queued = true;
      requestAnimationFrame(function () { queued = false; decorate(); });
    }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
    decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded',start,{once:true}); }
  else { start(); }
})();
